module.exports = __webpack_public_path__ + "static/2-25791ae8d4756369d540bf0d13951368.jpg";